import React from 'react';
import { Content, Wrapper } from './About.styled';


const About = () => {
    
    return (
        <section id="about">

            <Wrapper  >
                <Content>
                    <h1>About Me</h1>
                    <p>I'm Abir Hasan ,I’m a Freelance  Frontend Developer from Chittagong Bangladesh .I’ve spent about one years on improving my skills in website development using Html,css,sass,bootstrap, javascript & react js,styled component,material ui,react bootstrap & some animation libary like gasp,framer motion,i  & AOS also i have  basic tools knowladge on git & gitbash,photoshop,adobe xd,figma & also i have some knowladge on npm package manager  & I’m now pretty   confident in building website & react apps using these technology,libary,tools & packages manager


                    </p>

                    <a href="https://drive.google.com/file/d/1VrSJuIOUBcnUyjhEQ6KTH5WmAYcTiHAg/view" target="_blank" rel="noopener noreferrer">Download Resume</a>
                </Content>
            </Wrapper>
        </section>
    )
}

export default About
